import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Head from '@/components/base/Head';
import HeroSection from './components/HeroSection';
import DeclarationSection from './components/DeclarationSection';
import CategorySection from './components/CategorySection';
import LatestNewsSection from './components/LatestNewsSection';
import CTASection from './components/CTASection';
import CommentSection from './components/CommentSection';

export default function Home() {
  return (
    <>
      <Head />
      <Navbar />
      <main>
        <HeroSection />
        <DeclarationSection />
        <CategorySection />
        <LatestNewsSection />
        <CTASection />
        <CommentSection />
      </main>
      <Footer />
    </>
  );
}